module.exports = __webpack_public_path__ + "img/union.1618ba6f.svg";